import clsx from 'clsx';
import { ReactNode, useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { Link } from 'components';

import { ITrackEventProps } from 'typescriptDefs';

import { trackEvent, trackEventUniversal } from 'helpers';

import { LocaleContext } from './rebrand/Layout';

const BtnLogin = ({
  buttonLocation,
  className,
  children,
  trackEventProps,
}: {
  buttonLocation: string;
  children?: ReactNode | string;
  className?: string;
  trackEventProps: ITrackEventProps;
}): JSX.Element => {
  const locale = useContext(LocaleContext);
  const urlWeb = {
    en: `https://web.koho.ca/login`,
    fr: `https://web.koho.ca/login?language=fr`,
  }[locale];
  const label = {
    en: `Redirect to web KOHO login`,
    fr: `Redirection vers le site web de KOHO`,
  }[locale];

  return (
    <Link
      aria-label={label}
      onClick={() => {
        trackEventUniversal('Navigate to Login', {
          event_label: buttonLocation,
        });
        trackEventUniversal('"Log in" clicked', {
          event_label: buttonLocation,
        });
        trackEvent('Clicked login button', trackEventProps);
      }}
      target="_self"
      to={urlWeb}
      className={twMerge(clsx('px-16 py-8 hover:no-underline focus:no-underline active:no-underline', className))}
    >
      <p className="mb-0 text-md font-medium lg:text-sm">
        {children ? children : { en: `Log In`, fr: `Connexion` }[locale]}
      </p>
    </Link>
  );
};

export default BtnLogin;
